import React, { useContext } from "react";
import "antd/dist/antd.css";
import styles from "./Header.module.css";
import { PageHeader, Button, Typography } from "antd";
import { UserContext } from "../Reducers/UserContext";
import Lockr from "lockr";
const { Text } = Typography;

const style = { color: "white", fontSize: "10", padding: "8px 0" };

const Head = (props) => {
  const { isLoggedIn, setLogger } = useContext(UserContext);

  return (
    <PageHeader
      ghost={false}
      className={styles.pageheader}
      onBack={() => window.history.back()}
      title=""
      // subTitle={isLoggedIn["user"]["name"]}
      subTitle={
        <>
          <Text type="secondary">{isLoggedIn["user"]["name"]}</Text>
          <Text type="secondary" style={{ fontSize: "10px" }}>
            <div>({isLoggedIn["user"]["role"].toUpperCase()})</div>
          </Text>
        </>
      }
      extra={[
        <Button
          key="1"
          type="primary"
          size="small"
          style={{ margin: "inherit", right: "10px" }}
          onClick={() => {
            // remove stored Info
            localStorage.removeItem("myData");
            localStorage.removeItem("myName");
            localStorage.removeItem("myAvatar");
            localStorage.removeItem("role");
            Lockr.flush();
            setLogger({
              active: !isLoggedIn["active"],
              user: "",
            });
          }}
        >
          Logout
        </Button>,
      ]}
      avatar={{
        src: isLoggedIn["user"]["imgUrl"],
      }}
    ></PageHeader>
  );
};

export default Head;
